import {
    PAYMENT_FREQUENCIES,
} from '@ratehub/documents/mtg-journey-document/stable';


export default {
    [PAYMENT_FREQUENCIES.WEEKLY]: { frequency: 52, divisor: 1 },
    [PAYMENT_FREQUENCIES.ACCELERATED_WEEKLY]: { frequency: 12, divisor: 4 },

    [PAYMENT_FREQUENCIES.MONTHLY]: { frequency: 12, divisor: 1 },
    [PAYMENT_FREQUENCIES.SEMI_MONTHLY]: { frequency: 24, divisor: 1 },

    [PAYMENT_FREQUENCIES.BI_WEEKLY]: { frequency: 26, divisor: 1 },
    [PAYMENT_FREQUENCIES.ACCELERATED_BI_WEEKLY]: { frequency: 12, divisor: 2 },

    [PAYMENT_FREQUENCIES.QUARTERLY]: { frequency: 4, divisor: 1 },

    [PAYMENT_FREQUENCIES.ANNUALLY]: { frequency: 1, divisor: 1 },
};
